import { observer } from "mobx-react-lite";
import { ContextProps } from "@menu/core/types";
import { AnalyticsType, getAnalyticTags, gotoUrl } from "@menu/core/lib";

const InboxIcon = observer((props: ContextProps) => {
    const { inbox, config } = props.context;
    const { display, url, unread } = inbox;

    if (!display && !config.alwaysShowInbox) {
        return null;
    }

    const analyticTags = () => {
        const item = AnalyticsType.menu;
        const name = `header_inbox_icon`;
        const text = "inbox-icon";

        return getAnalyticTags({
            component_name: name,
            nav_item: item,
            nav_text: text,
            target_page_url: url
        });
    }

    return (<span className="inbox-icon">
        <i className="icon-imi-inbox"
        {...analyticTags()}
            onClick={() => gotoUrl(url)} />
        {unread > 0 && <i className="unread-count">{unread}</i>}
    </span>);
});

export default InboxIcon;